module.exports = __webpack_public_path__ + "img/bgtemp.798982a3.png";